import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrows-dn",
  "use": "icon-arrows-dn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrows-dn\"><defs><style type=\"text/css\"></style></defs><path d=\"M511 628.9L212.6 330.5c-11.7-11.7-30.7-11.7-42.4 0s-11.7 30.7 0 42.4l317.7 317.7c0.6 0.7 1.2 1.4 1.9 2.1 11.7 11.7 30.7 11.7 42.4 0l319.4-319.4c11.7-11.7 11.7-30.7 0-42.4s-30.7-11.7-42.4 0L511 628.9z\" p-id=\"6090\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrows-dn.svg
// module id = FZnD
// module chunks = 65